export enum PttTargetType {
  TAXI = "taxi",
  FLEET = "fleet",
  AGENT = "agent",
}

export enum PttOriginType {
  TAXI = "taxi",
  AGENT = "agent",
}

export interface PttTarget {
  type: PttTargetType;
  id?: number;
}

export interface RecordingData {
  audio: Blob;
  wgId: number;
  centralId: number;
  target: string;
  taxiId?: number;
}
